.ax{aspect-ratio:1/1;}